import React, { useEffect, useState } from "react";
import { TableauViz } from "@tableau/embedding-api-react";
import useSession from "../../hooks/useSession";
import { useUserInfo } from "../../hooks/useUserInfo";
import { TableauTokenPayload } from "../../types/analytics";

type TableauEmbedProps = {
  src: string;
  height?: string | number;
};

export default function TableauEmbed({ src, height = "100%" }: TableauEmbedProps) {
  const [jwt, setJwt] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const { tenant, consumer } = useUserInfo();
  const { api } = useSession();

  const tenantCode = tenant?.tenantCode;
  const consumerCode =
    consumer?.consumerCode

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        if (!tenantCode || !consumerCode) {
          if (!cancelled) setError("Missing tenantCode or consumerCode");
          return;
        }

        const payload: TableauTokenPayload = { tenantCode, consumerCode };
        const response = await api.getToken(payload);
        const token = response?.token;

        if (!token) throw new Error("Token API returned no jwt");
        if (!cancelled) setJwt(token);
      } catch (e: any) {
        if (!cancelled) setError(e.message || "Failed to get Tableau token");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tenantCode, consumerCode, api, src]);

  if (error) return <div style={{ color: "crimson" }}>You don't have access to this report</div>;
  if (!jwt) return <div>Loading reports…</div>;

  return (
    <div style={{ width: '100%', height, overflow: 'auto' }}>
      <TableauViz src={src} token={jwt} toolbar="hidden" height="100%" />
    </div>
  );
}